module.exports = __webpack_public_path__ + "static/media/ice40.2020f0de.webp";